import { Button } from '@/components/ui/button'
import { Save, ChevronDown } from 'lucide-react'
import { useTranslation } from '@/i18n'

const TABS = [
  { id: 'page-mapping', labelKey: 'pidSet.tabs.pageMapping', defaultLabel: 'Page Mapping' },
  { id: 'editor-mode', labelKey: 'pidSet.tabs.editorMode', defaultLabel: 'Editor Mode' },
  { id: 'graph-preview', labelKey: 'pidSet.tabs.graphPreview', defaultLabel: 'Graph Preview' },
  { id: 'json', labelKey: 'pidSet.tabs.json', defaultLabel: 'JSON' },
  { id: 'original', labelKey: 'pidSet.tabs.original', defaultLabel: 'Original' },
] as const

interface PidSetSubNavbarProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

export default function PidSetSubNavbar({ activeTab, onTabChange }: PidSetSubNavbarProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between border-b border-border bg-background px-6 py-3 shrink-0">
      {/* Tab pills */}
      <div className="flex items-center h-8 bg-muted rounded-lg p-[3px]">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={`h-full px-3 py-1 rounded-md text-sm font-medium whitespace-nowrap transition-all ${
                isActive
                  ? 'bg-background text-foreground shadow-sm border border-transparent'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {t(`graph_editor:${tab.labelKey}`, { defaultValue: tab.defaultLabel })}
            </button>
          )
        })}
      </div>

      {/* Right side: version dropdown + save button */}
      <div className="flex items-center gap-3">
        <div className="flex items-center w-[148px] gap-1.5 rounded-lg border border-input bg-background px-2.5 py-2 opacity-50">
          <span className="flex-1 text-sm text-muted-foreground truncate">{t('graph_editor:version.label', { count: 1, defaultValue: 'Version {{count}}' })}</span>
          <ChevronDown className="size-4 text-muted-foreground shrink-0" />
        </div>
        <Button size="sm" disabled className="gap-1.5 h-8">
          <Save className="size-4" />
          {t('graph_editor:pidSet.saveChanges', { defaultValue: 'Save Changes' })}
        </Button>
      </div>
    </div>
  )
}
